<template>
  <div v-if="show" class="footerBox">
    <van-tabbar v-model="active" @change="onClick">
      <van-tabbar-item
        v-for="(item, index) in tablist"
        :key="index"
        :icon="item.icon"
        :name="index"
      >
        {{ item.text }}
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "FooterBox",
  data() {
    return {
      show: true,
      active: 0,
      tablist: [
        {
          icon: "wap-home-o",
          text: "客户报备",
          url: "/",
        },
        {
          icon: "todo-list-o",
          text: "报备列表",
          url: "/list",
        },
        {
          icon: "orders-o",
          text: "报备完成",
          url: "/complete",
        },
        {
          icon: "user-o",
          text: "我的",
          url: "/my",
        },
      ],
    };
  },
  methods: {
    onClick(active) {
      console.log("active", active);
      console.log("active", this.tablist[active]);
      let item = this.tablist[active];
      this.$router.push({
        path: item.url,
      });
      this.active = active;
    },

    checkRoute(to) {
      let checkRoutes = ["/register", "/login"];
      let otherRoute = ["/authorize", "/auth"];
      let path = to.path;
      let isLogin = this.$store.state.isLogin;
      let usertype = this.$store.state.usertype;

      if (otherRoute.findIndex((item) => item == path) != -1) {
        return;
      }
      // 已登录访问注册页面，返回首页
      if (isLogin && checkRoutes.findIndex((item) => item == path) != -1) {
        console.log("usertype", usertype);
        this.$router.push({
          path: "/list",
        });
      }
      // 未登录访问业务页面，返回登录页
      if (!isLogin && checkRoutes.findIndex((item) => item == path) == -1) {
        Dialog.alert({
          message: "您还未登录，请您登录！",
        }).then(() => {
          this.$router.push({
            path: "/login",
          });
        });
      }
      console.log(
        isLogin,
        path,
        checkRoutes.findIndex((item) => item == path)
      );
    },
  },
  created() {
    // this.init();
  },
  watch: {
    $route(to) {
      // this.init();
      let that = this;
      that.active = -1;
      that.tablist.forEach(function (item, index) {
        if (item.url == "/" && item.url == to.path) {
          that.active = index;
        }
        if (item.url != "/" && to.path.indexOf(item.url) == 0) {
          that.active = index;
        }
        console.log("topath", to.path, item.url);
        console.log(item.url != "/" && item.url.indexOf(to.path) != -1);
        console.log(item.url != "/" && to.path.indexOf(item.url) == 0);
      });
      if (that.active == -1) {
        that.show = false;
      } else {
        that.show = true;
      }

      this.checkRoute(to);
    },
  },
};
</script>

<style scoped>
.footerBox {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 512px;
  padding: 0;
  font-size: 9px;
}

/*.footerBox {
  width: 100%;
  !*max-width: 512px;*!
  left: calc(50% - 256px);
  !*height: 80px;*!
  z-index: 999;
}*/
</style>
